import { render, staticRenderFns } from "./PoetSunOfArt.vue?vue&type=template&id=f09f20f8&scoped=true&lang=pug&"
import script from "./PoetSunOfArt.vue?vue&type=script&lang=js&"
export * from "./PoetSunOfArt.vue?vue&type=script&lang=js&"
import style0 from "./PoetSunOfArt.vue?vue&type=style&index=0&id=f09f20f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09f20f8",
  null
  
)

export default component.exports